/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type RemoveUserVariableDefinitionValueSelectOptionError =
  /** すでに使用されているため削除できない */
  | 'ALREADY_USED'
  | 'UNKNOWN';

export type RemoveUserVariableDefinitionValueSelectOptionInput = {
  selectOptionGUID: string | number;
  userVariableDefinitionGUID: string | number;
};

export type UpdateUserVariableDefinitionValueSelectOptionInput = {
  name: string;
  selectOptionGUID: string | number;
  userVariableDefinitionGUID: string | number;
};

export type SettingsPageLineActivationUserVariableDefinitionValueSelectOptionEditRowOptionFragment = { guid: string, name: string };

export type UpdateUserVariableDefinitionValueSelectOptionMutationVariables = Exact<{
  input: Types.UpdateUserVariableDefinitionValueSelectOptionInput;
}>;


export type UpdateUserVariableDefinitionValueSelectOptionMutation = { updateUserVariableDefinitionValueSelectOption: { void: any } };

export type RemoveUserVariableDefinitionValueSelectOptionMutationVariables = Exact<{
  input: Types.RemoveUserVariableDefinitionValueSelectOptionInput;
}>;


export type RemoveUserVariableDefinitionValueSelectOptionMutation = { removeUserVariableDefinitionValueSelectOption:
    | { __typename: 'RemoveUserVariableDefinitionValueSelectOptionErrorPayload', error: Types.RemoveUserVariableDefinitionValueSelectOptionError }
    | { __typename: 'RemoveUserVariableDefinitionValueSelectOptionSuccessPayload' }
   };

export const SettingsPageLineActivationUserVariableDefinitionValueSelectOptionEditRowOptionFragmentDoc = gql`
    fragment SettingsPageLineActivationUserVariableDefinitionValueSelectOptionEditRowOption on UserVariableDefinitionValueSelectOption {
  guid
  name
}
    `;
export const UpdateUserVariableDefinitionValueSelectOptionDocument = gql`
    mutation UpdateUserVariableDefinitionValueSelectOption($input: UpdateUserVariableDefinitionValueSelectOptionInput!) {
  updateUserVariableDefinitionValueSelectOption(input: $input) {
    void
  }
}
    `;

/**
 * __useUpdateUserVariableDefinitionValueSelectOptionMutation__
 *
 * To run a mutation, you first call `useUpdateUserVariableDefinitionValueSelectOptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserVariableDefinitionValueSelectOptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserVariableDefinitionValueSelectOptionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserVariableDefinitionValueSelectOptionMutation(options: VueApolloComposable.UseMutationOptions<UpdateUserVariableDefinitionValueSelectOptionMutation, UpdateUserVariableDefinitionValueSelectOptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateUserVariableDefinitionValueSelectOptionMutation, UpdateUserVariableDefinitionValueSelectOptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateUserVariableDefinitionValueSelectOptionMutation, UpdateUserVariableDefinitionValueSelectOptionMutationVariables>(UpdateUserVariableDefinitionValueSelectOptionDocument, options);
}
export type UpdateUserVariableDefinitionValueSelectOptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateUserVariableDefinitionValueSelectOptionMutation, UpdateUserVariableDefinitionValueSelectOptionMutationVariables>;
export const RemoveUserVariableDefinitionValueSelectOptionDocument = gql`
    mutation RemoveUserVariableDefinitionValueSelectOption($input: RemoveUserVariableDefinitionValueSelectOptionInput!) {
  removeUserVariableDefinitionValueSelectOption(input: $input) {
    __typename
    ... on RemoveUserVariableDefinitionValueSelectOptionErrorPayload {
      error
    }
  }
}
    `;

/**
 * __useRemoveUserVariableDefinitionValueSelectOptionMutation__
 *
 * To run a mutation, you first call `useRemoveUserVariableDefinitionValueSelectOptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserVariableDefinitionValueSelectOptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveUserVariableDefinitionValueSelectOptionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUserVariableDefinitionValueSelectOptionMutation(options: VueApolloComposable.UseMutationOptions<RemoveUserVariableDefinitionValueSelectOptionMutation, RemoveUserVariableDefinitionValueSelectOptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveUserVariableDefinitionValueSelectOptionMutation, RemoveUserVariableDefinitionValueSelectOptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveUserVariableDefinitionValueSelectOptionMutation, RemoveUserVariableDefinitionValueSelectOptionMutationVariables>(RemoveUserVariableDefinitionValueSelectOptionDocument, options);
}
export type RemoveUserVariableDefinitionValueSelectOptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveUserVariableDefinitionValueSelectOptionMutation, RemoveUserVariableDefinitionValueSelectOptionMutationVariables>;